import React, { Component } from 'react';
import InputList from '../../../shared/components/presentation/input-list/InputList';
import { Grid, GridItem } from '../../../shared/components/presentation/grid/Grid';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as webAppointmentActions from '../../actions/webAppointmentActions';
import * as regex from '../../../constants/regex';
import { nextPage } from '../../functions/nextPage';
import * as defaultState from '../../constants/DefaultState';
import * as strings from '../../constants/strings';
import * as formatData from '../../functions/formatData';
import { dropDownDefault } from '../../constants/webAppointmentConstants'

export class AppointmentInfo2Page extends Component {
  languages = [
    { name: 'Afrikaans', value: '1-afrikaans' },
    { name: 'Akan', value: '96-akan' },
    { name: 'Albanian', value: '2-albanian' },
    { name: 'Amharic', value: '3-amharic' },
    { name: 'Arabic', value: '4-arabic' },
    { name: 'Armenian', value: '69-armenian' },
    { name: 'Assyrian', value: '97-assyrian' },
    { name: 'Azerbaijani', value: '98-azerbaijani' },
    { name: 'Bambara', value: '102-bambara' },
    { name: 'Basque', value: '99-basque' },
    { name: 'Bedawi', value: '100-bedawi' },
    { name: 'Belorussian', value: '101-belorussian' },
    { name: 'Bengali', value: '5-bengali' },
    { name: 'Bokmail', value: '6-bokmail' },
    { name: 'Bosnian', value: '103-bosnian' },
    { name: 'Bulgarian', value: '7-bulgarian' },
    { name: 'Burmese', value: '8-burmese' },
    { name: 'Cajun', value: '70-cajun' },
    { name: 'Cambodian', value: '9-cambodian' },
    { name: 'Cantonese', value: '71-cantonese' },
    { name: 'Catalan', value: '10-catalan' },
    { name: 'Chaldean', value: '106-chaldean' },
    { name: 'Chaochow', value: '105-chaochow' },
    { name: 'Chavacano', value: '104-chavacano' },
    { name: 'Cherokee', value: '107-cherokee' },
    { name: 'Chinese', value: '11-chinese' },
    { name: 'Creole', value: '108-creole' },
    { name: 'Croatian', value: '12-croatian' },
    { name: 'Czech', value: '13-czech' },
    { name: 'Dakota', value: '110-dakota' },
    { name: 'Danish', value: '14-danish' },
    { name: 'Dari Persian', value: '15-dari persian' },
    { name: 'Diula', value: '109-diula' },
    { name: 'Divehi', value: '16-divehi' },
    { name: 'Druk Ke', value: '17-druk ke' },
    { name: 'Dutch', value: '18-dutch' },
    { name: 'English', value: '66-english', selected: true },
    { name: 'Estonian', value: '111-estonian' },
    { name: 'Ethiopian', value: '112-ethiopian' },
    { name: 'Farsi', value: '113-farsi' },
    { name: 'Fijian', value: '114-fijian' },
    { name: 'Finnish', value: '19-finnish' },
    { name: 'Flemish', value: '115-flemish' },
    { name: 'Formosan', value: '73-formosan' },
    { name: 'French', value: '20-french' },
    { name: 'French Canadian', value: '116-french canadian' },
    { name: 'French Creole', value: '74-french creole' },
    { name: 'Fukienese', value: '117-fukienese' },
    { name: 'Fushtu', value: '21-fushtu' },
    { name: 'Fuzhou', value: '118-fuzhou' },
    { name: 'Ga', value: '119-ga' },
    { name: 'Gaddang', value: '120-gaddang' },
    { name: 'Gaelic', value: '22-gaelic' },
    { name: 'German', value: '23-german' },
    { name: 'Greek', value: '24-greek' },
    { name: 'Gujarathi', value: '75-gujarathi' },
    { name: 'Haitian Creole', value: '126-haitian creole' },
    { name: 'Hakka', value: '123-hakka' },
    { name: 'Hausa', value: '121-hausa' },
    { name: 'Hawaiian', value: '122-hawaiian' },
    { name: 'Hebrew', value: '25-hebrew' },
    { name: 'Hindi', value: '76-hindi' },
    { name: 'Hindu', value: '26-hindu' },
    { name: 'Hmong', value: '125-hmong' },
    { name: 'Hokkien', value: '124-hokkien' },
    { name: 'Hunanese', value: '127-hunanese' },
    { name: 'Hungarian', value: '77-hungarian' },
    { name: 'Ibanag', value: '128-ibanag' },
    { name: 'Ibo', value: '129-ibo' },
    { name: 'Icelandic', value: '27-icelandic' },
    { name: 'Ilocano', value: '78-ilocano' },
    { name: 'Indian', value: '187-indian' },
    { name: 'Indonesian', value: '28-indonesian' },
    { name: 'Iranian', value: '68-iranian' },
    { name: 'Italian', value: '29-italian' },
    { name: 'Jakartanese', value: '132-jakartanese' },
    { name: 'Japanese', value: '30-japanese' },
    { name: 'Jarai', value: '130-jarai' },
    { name: 'Javanese', value: '131-javanese' },
    { name: 'Jola', value: '133-jola' },
    { name: 'Kanjobal', value: '134-kanjobal' },
    { name: 'Kannada', value: '139-kannada' },
    { name: 'Karen', value: '192-karen' },
    { name: 'Kashmiri', value: '135-kashmiri' },
    { name: 'Khaliji', value: '138-khaliji' },
    { name: 'Khmer', value: '136-khmer' },
    { name: 'Kikuyu', value: '137-kikuyu' },
    { name: 'Kinyarwand', value: '31-kinyarwand' },
    { name: 'Korean', value: '32-korean' },
    { name: 'Krio', value: '140-krio' },
    { name: 'Kru', value: '79-kru' },
    { name: 'Kurdish', value: '141-kurdish' },
    { name: 'Lao', value: '33-lao' },
    { name: 'Latvian', value: '145-latvian' },
    { name: 'Lingala', value: '143-lingala' },
    { name: 'Lithuanian', value: '80-lithuanian' },
    { name: 'Loaotian', value: '144-loaotian' },
    { name: 'Luganda', value: '142-luganda' },
    { name: 'Luxembourgeois', value: '146-luxembourgeois' },
    { name: 'Macedoniar', value: '34-macedoniar' },
    { name: 'Magyar', value: '35-magyar' },
    { name: 'Mai Mai', value: '184-mai mai' },
    { name: 'Malagasy', value: '37-malagasy' },
    { name: 'Malasy', value: '36-malasy' },
    { name: 'Malay, Indonesian', value: '81-malay, indonesian' },
    { name: 'Malayalam', value: '82-malayalam' },
    { name: 'Maltese', value: '38-maltese' },
    { name: 'Mandarin', value: '147-mandarin' },
    { name: 'Mandinka', value: '149-mandinka' },
    { name: 'Marathi', value: '83-marathi' },
    { name: 'Marshallese', value: '150-marshallese' },
    { name: 'Mien', value: '148-mien' },
    { name: 'Min Nan', value: '84-min nan' },
    { name: 'Mongolian', value: '39-mongolian' },
    { name: 'Moslawi', value: '151-moslawi' },
    { name: 'Najdi', value: '154-najdi' },
    { name: 'Nauran', value: '40-nauran' },
    { name: 'Navaho', value: '85-navaho' },
    { name: 'Neapolitan', value: '152-neapolitan' },
    { name: 'Nepali', value: '41-nepali' },
    { name: 'Nigerian Pidgin English', value: '153-nigerian pidgin english' },
    { name: 'Norwegian', value: '65-norwegian' },
    { name: 'Nynorak', value: '42-nynorak' },
    { name: 'Oromo', value: '155-oromo' },
    { name: 'Pakistani', value: '160-pakistani' },
    { name: 'Pampangan', value: '156-pampangan' },
    { name: 'Pangasinan', value: '157-pangasinan' },
    { name: 'Panjabi', value: '86-panjabi' },
    { name: 'Papiamento', value: '158-papiamento' },
    { name: 'Papuan Languages', value: '43-papuan languages' },
    { name: 'Pashto', value: '191-pashto' },
    { name: 'Pennsylvania-Dutch', value: '87-pennsylvania-dutch' },
    { name: 'Persian', value: '44-persian' },
    { name: 'Pidgin English', value: '159-pidgin english' },
    { name: 'Po An', value: '161-po an' },
    { name: 'Polish', value: '45-polish' },
    { name: 'Portugese', value: '46-portugese' },
    { name: 'Protuguese Creole', value: '163-protuguese creole' },
    { name: 'Pushto', value: '162-pushto' },
    { name: 'Qatari', value: '165-qatari' },
    { name: 'Quechuna', value: '164-quechuna' },
    { name: 'Quiche', value: '166-quiche' },
    { name: 'Rhade', value: '167-rhade' },
    { name: 'Romanian', value: '47-romanian' },
    { name: 'Russian', value: '48-russian' },
    { name: 'Ruthian', value: '188-ruthian' },
    { name: 'Samoan', value: '89-samoan' },
    { name: 'Serbcroatian', value: '90-serbcroatian' },
    { name: 'Serbian', value: '173-serbian' },
    { name: 'Shanghai', value: '169-shanghai' },
    { name: 'Sicilian', value: '170-sicilian' },
    { name: 'Sindhi', value: '172-sindhi' },
    { name: 'Sinhala', value: '50-sinhala' },
    { name: 'Sioux', value: '171-sioux' },
    { name: 'Siswati', value: '51-siswati' },
    { name: 'Slovak', value: '53-slovak' },
    { name: 'Slovene', value: '52-slovene' },
    { name: 'Somalia', value: '185-somalia' },
    { name: 'Somoan', value: '54-somoan' },
    { name: 'Spanish', value: '55-spanish' },
    { name: 'Sudanese', value: '174-sudanese' },
    { name: 'Swahili', value: '56-swahili' },
    { name: 'Swedish', value: '57-swedish' },
    { name: 'Syriac', value: '95-syriac' },
    { name: 'Szechuan', value: '168-szechuan' },
    { name: 'Tagalog-Filipino ', value: '58-tagalog-filipino ' },
    { name: 'Taiwanese', value: '177-taiwanese' },
    { name: 'Tamil', value: '92-tamil' },
    { name: 'Thai', value: '59-thai' },
    { name: 'Tibetian', value: '60-tibetian' },
    { name: 'Tongan', value: '61-tongan' },
    { name: 'Toucouleur', value: '175-toucouleur' },
    { name: 'Tshiluba', value: '176-tshiluba' },
    { name: 'Turkish', value: '62-turkish' },
    { name: 'Ukranian', value: '93-ukranian' },
    { name: 'Urdu', value: '63-urdu' },
    { name: 'Vietnamese', value: '64-vietnamese' },
    { name: 'Visayan', value: '178-visayan' },
    { name: 'Wolof', value: '179-wolof' },
    { name: 'Xhosa', value: '180-xhosa' },
    { name: 'Yiddish', value: '94-yiddish' },
    { name: 'Yoruba', value: '181-yoruba' },
    { name: 'Yugoslavian', value: '182-yugoslavian' },
    { name: 'Zulu', value: '183-zulu' },
  ];

  isValid() {
    let valid = (
      this.props.appointment.translationInterpretationServices.needServices !== null &&
      this.props.appointment.referringPhysician.haveReferringPhys !== null &&
      this.props.appointment.translationInterpretationServices.language
    );

    if (this.props.appointment.translationInterpretationServices.needServices) {
      valid = valid && this.props.appointment.translationInterpretationServices.whichService;
    }

    if (this.props.appointment.referringPhysician.haveReferringPhys) {
      valid = (
        valid &&
        this.props.appointment.referringPhysician.firstName &&
        this.props.appointment.referringPhysician.lastName &&
        this.props.appointment.referringPhysician.phone &&
        this.props.appointment.referringPhysician.phone.match(regex.NUMERIC_PHONE_NUMBER_REGEX)
      );
    }

    return !!valid;
  }

  render() {
    const title = "Tell us about " + (this.props.forMe ? "your" : "their") + " appointment needs (cont.).";

    //sets preferred language by default if selected
    if (!this.props.appointment.translationInterpretationServices.language && this.languages.find(l => l.selected === true)) {
      this.props.webAppointmentSetAppointmentForeignLanguage(this.languages.find(l => l.selected === true).name);
    }

    let inputlist = [
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        inputs: [
          {
            type: 'radio-list',
            id: 'need-services',
            groupName: 'need-services',
            legend: 'Do ' + (this.props.forMe ? "you" : "they") + ' need interpretation services?',
            required: true,
            onChange: (ev) => { this.props.webAppointmentSetAppointmentNeedServices(ev.target.value === "yes"); },
            radioWrapperClassName: 'radio-button-inline radio-button-bold',
            radioProps: [
              {
                id: "yes-need-interpreter",
                label: "Yes",
                value: "yes",
                checked: this.props.appointment.translationInterpretationServices.needServices
              },
              {
                id: "no-need-interpreter",
                label: "No",
                value: "no",
                checked: !this.props.appointment.translationInterpretationServices.needServices
              }
            ]
          },
          this.props.appointment.translationInterpretationServices.needServices ?
            {
              type: 'radio-list',
              id: 'which-services',
              groupName: 'what-services',
              legend: 'Please indicate which service ' + (this.props.forMe ? "you" : "they") + ' need.',
              required: true,
              onChange: (ev) => { this.props.webAppointmentSetAppointmentWhichService(ev.target.value); },
              radioWrapperClassName: 'radio-button-inline radio-button-bold',
              radioProps: [
                {
                  id: "asl-service",
                  label: "ASL interpretation",
                  value: strings.ASL,
                  checked: this.props.appointment.translationInterpretationServices.whichService === strings.ASL
                },
                {
                  id: "interpretation-service",
                  label: strings.FOREIGN_LANGUAGE_INTERPRETATION,
                  value: strings.FOREIGN_LANGUAGE_INTERPRETATION,
                  checked: this.props.appointment.translationInterpretationServices.whichService === strings.FOREIGN_LANGUAGE_INTERPRETATION
                }
              ]
            } : null,
          {
            type: 'select',
            id: 'foreign-language',
            key: 'foreign-language',
            label: 'What is ' + (this.props.forMe ? "your" : "their") + ' primary language?',
            required: true,
            requiredError: 'Please enter ' + (this.props.forMe ? "your" : "their") + ' primary language.',
            validateOnBlur: true,
            validationErrorClass: "web-appointment__error",
            onChange: (value) => {
              value = this.languages.find(l => l.value === value);
              this.props.webAppointmentSetAppointmentForeignLanguage(value === this.languages.find(l => l.selected === true) ?
                this.languages.find(l => l.selected === true).name : value.name);
            },
            existingContent: this.props.appointment.translationInterpretationServices.language ?
              this.props.appointment.translationInterpretationServices.language.value :
              this.languages.find(l => l.selected === true).value,
            options: this.languages
          },
          {
            type: 'radio-list',
            id: 'referred-by-physician',
            groupName: 'referred-by-physician',
            legend: 'Were ' + (this.props.forMe ? "you" : "they") + ' referred by a physician?',
            required: true,
            onChange: (ev) => { this.props.webAppointmentSetAppointmentHaveReferringPhys(ev.target.value === "yes"); },
            helperText: 'Please check with ' + (this.props.forMe ? "your" : "their") + ' insurance company to find out if a referral is needed. If you’re scheduling an appointment in Nevada, a referral is required.',
            radioWrapperClassName: 'radio-button-inline radio-button-bold',
            radioProps: [
              {
                id: "yes-referred",
                label: "Yes",
                value: "yes",
                checked: this.props.appointment.referringPhysician.haveReferringPhys
              },
              {
                id: "no-referred",
                label: "No",
                value: "no",
                checked: !this.props.appointment.referringPhysician.haveReferringPhys
              }
            ]
          }
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 2,
        inputs: [
          [
            this.props.appointment.referringPhysician.haveReferringPhys ? {
              type: 'text',
              id: 'firstName',
              label: "Physician’s first name",
              required: true,
              requiredError: "Please enter the physician’s first name.",
              validateOnBlur: true,
              validationErrorClass: "web-appointment__error",
              onChange: (ev) => { this.props.webAppointmentSetAppointmentReferringPhysFName(ev.target.value); },
              existingContent: this.props.appointment.referringPhysician.firstName || undefined,
              maxLength: '140'
            } : null
          ],
          [
            this.props.appointment.referringPhysician.haveReferringPhys ? {
              type: 'text',
              id: 'lastName',
              label: "Physician’s last name",
              required: true,
              requiredError: "Please enter the physician’s last name.",
              validateOnBlur: true,
              validationErrorClass: "web-appointment__error",
              onChange: (ev) => { this.props.webAppointmentSetAppointmentReferringPhysLName(ev.target.value); },
              existingContent: this.props.appointment.referringPhysician.lastName || undefined,
              maxLength: '140'
            } : null
          ]
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 2,
        inputs: [
          [
            this.props.appointment.referringPhysician.haveReferringPhys ? {
              type: 'text',
              id: 'phone',
              label: "Physician’s phone number",
              required: true,
              requiredError: "Please enter the physician’s phone number with the area code.",
              patternMatch: regex.NUMERIC_PHONE_NUMBER_REGEX,
              patternMatchError: "Please enter the physician’s phone number with the area code.",
              validateOnBlur: true,
              validateOnChange: true,
              validationErrorClass: "web-appointment__error",
              onChange: (ev) => {
                let newValues = formatData.formatPhone(ev.target.value, ev.target.selectionStart);
                this.props.webAppointmentSetAppointmentReferringPhysPhone(newValues.value);
                return newValues;
              },
              existingContent: this.props.appointment.referringPhysician.phone,
              maxLength: '14'
            } : null
          ]
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order margin-top-medium",
        inputs: [
          [
            {
              type: 'button',
              id: "back",
              className: "btn--secondary",
              value: 'Back',
              onClick: () => {
                this.props.history.goBack();
              }
            },
            {
              type: 'button',
              id: "next",
              className: "btn--primary",
              value: "Next",
              disabled: !this.isValid(),
              onClick: () => {
                this.props.history.push(nextPage());
              }
            }
          ]
        ]
      }
    ];

    return (
      <React.Fragment>
        <Grid columns={1}>
          <GridItem>
            <div className='web-appt__header'>
              <h1>{title}</h1>
              <hr />
            </div>
          </GridItem>
        </Grid>
        <InputList inputs={inputlist} isInlineList={false} />
      </React.Fragment>
    );
  }
}

AppointmentInfo2Page.propTypes = {
  appointment: defaultState.appointmentProptype,
  forMe: PropTypes.bool.isRequired,
  webAppointmentSetAppointmentHaveReferringPhys: PropTypes.func.isRequired,
  webAppointmentSetAppointmentNeedServices: PropTypes.func.isRequired,
  webAppointmentSetAppointmentWhichService: PropTypes.func.isRequired,
  webAppointmentSetAppointmentForeignLanguage: PropTypes.func.isRequired,
  webAppointmentSetAppointmentReferringPhysFName: PropTypes.func.isRequired,
  webAppointmentSetAppointmentReferringPhysLName: PropTypes.func.isRequired,
  webAppointmentSetAppointmentReferringPhysPhone: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    appointment: state.webAppointmentForm.appointment,
    forMe: state.webAppointmentForm.forMe
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    webAppointmentSetAppointmentNeedServices: (value) => dispatch(webAppointmentActions.webAppointmentSetAppointmentNeedServices(value)),
    webAppointmentSetAppointmentWhichService: (value) => dispatch(webAppointmentActions.webAppointmentSetAppointmentWhichService(value)),
    webAppointmentSetAppointmentForeignLanguage: (value) => dispatch(webAppointmentActions.webAppointmentSetAppointmentForeignLanguage(value)),
    webAppointmentSetAppointmentHaveReferringPhys: (value) => dispatch(webAppointmentActions.webAppointmentSetAppointmentHaveReferringPhys(value)),
    webAppointmentSetAppointmentReferringPhysFName: (value) => dispatch(webAppointmentActions.webAppointmentSetAppointmentReferringPhysFName(value)),
    webAppointmentSetAppointmentReferringPhysLName: (value) => dispatch(webAppointmentActions.webAppointmentSetAppointmentReferringPhysLName(value)),
    webAppointmentSetAppointmentReferringPhysPhone: (value) => dispatch(webAppointmentActions.webAppointmentSetAppointmentReferringPhysPhone(value))
  };
};

// connects component to redux, and passes along the router
export default connect(mapStateToProps, mapDispatchToProps)(AppointmentInfo2Page);
